module.exports = __webpack_public_path__ + "static/img/home_jrtt_pic2.c939c6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_jrtt_pic2.png
// module id = hVCu
// module chunks = 0